import React from 'react';
import { Tabs } from 'antd';

import PillarThreeComponentGuide from './PillarThreeComponentGuide';
import type { PillarThreeGuideKey } from './PillarThreeComponentGuide';
import PillarThreeOverviewGuide from './PillarThreeOverviewGuide';

const emptyWorkspace = (label: string) => (
  <section
    aria-label={`${label} workspace`}
    className="assessment-inspect-assessment__pillar-one-component-empty"
  />
);

const componentWorkspace = (label: string, component: PillarThreeGuideKey) => (
  <div className="assessment-inspect-assessment__detail-panel assessment-inspect-assessment__detail-panel--pillar-one">
    {emptyWorkspace(label)}
    <PillarThreeComponentGuide component={component} />
  </div>
);

const PILLAR_THREE_TABS = [
  {
    key: 'pillar-3-overview',
    label: 'Pillar 3 overview',
    children: (
      <div className="assessment-inspect-assessment__detail-panel assessment-inspect-assessment__detail-panel--pillar-one">
        {emptyWorkspace('Pillar 3 overview')}
        <PillarThreeOverviewGuide />
      </div>
    ),
  },
  {
    key: 'risk-size',
    label: 'Risk size & intended loss(40%)',
    children: componentWorkspace('Risk size and intended loss', 'risk-size'),
  },
  {
    key: 'common-factors',
    label: 'Aggregate common factors(35%)',
    children: componentWorkspace('Aggregate common factors', 'common-factors'),
  },
  {
    key: 'risk-adaptation',
    label: 'Risk adaptation(25%)',
    children: componentWorkspace('Risk adaptation', 'risk-adaptation'),
  },
];

const PillarThreeComponentTabs: React.FC = () => (
  <Tabs
    className="assessment-inspect-assessment__pillar-one-component-tabs"
    defaultActiveKey="pillar-3-overview"
    destroyOnHidden
    items={PILLAR_THREE_TABS}
  />
);

export default PillarThreeComponentTabs;
